
import {Component, Vue} from "vue-property-decorator";
import QrCodeReader from "@/components/QrCodeReader.vue";

@Component({
    components: {QrCodeReader},
})
export default class HandToHand extends Vue {
    private keyId: number = null;
    private token: string = null;
    private key: any = {};
    private qrCodeReaderError: any = null;
    private loadingQrCodeStreamer: boolean = false;

    private mounted() {
        this.keyId = Number(this.$route.params.keyId);
        this.token = this.$route.params.token;
        this.getKeyById();
    }

    private readQRCode(params: {token: string, moveAllSubObjects?: boolean}): Promise<any> {
        const {token} = params;
        this.qrCodeReaderError = null;
        this.loadingQrCodeStreamer = true;
        return this.$store.dispatch("keys/recoverHandToHand", {
          token,
          keyId: this.keyId,
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
                iconGroup: "icon-picto_recevoir-main-a-main",
                msg: this.$i18n?.t("alerts.key.retrieveSuccess", {key: this.key.name}),
            });
            this.$router.push({name: "keys"});
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
              iconGroup: "icon-picto_recevoir-main-a-main",
              msg: this.$t(`alerts.error.${err?.response?.data?.error || "default"}`),
            });
        }).finally(() => {
            this.loadingQrCodeStreamer = false;
        });
    }

    private getKeyById() {
        return this.$store.dispatch("keys/getById", {
            id: this.keyId,
            options: {
                picture: true,
            },
        })
        .then((key) => {
            this.key = key;
        }).catch((err) => {
            this.$store.commit("alerts/displayError", {
                msg: err,
            });
        });
    }

}
